import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import TabbedPane from '../../components/plain/TabbedPane';
import Label from '../../components/plain/Label';
import LabelField from '../../components/plain/LabelField';
import FieldString from '../../components/plain/FieldString';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldReference from '../../components/plain/FieldReference';
import FieldRefList from '../../components/plain/FieldRefList';
import FieldCheckBoxGroup from '../../components/plain/FieldCheckBoxGroup';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';
import SelectMerchantsModal from '../../modal/SelectMerchantsModal';
import SelectTerminalsModal from '../../modal/SelectTerminalsModal';
import KatottgButton from '../../components/katottgtree/KatottgButton';

import {getUserInfo, hasAccess} from '../../util/localStorage';
import { getDefinedValue } from '../../util/tools';
import {CLASS_BOOKSHOP, CLASS_PROVIDER } from '../../util/consts/classes';
import {ACCESS_VIEW_BOOKSHOP_AREA} from '../../util/consts/actions';
import {FORM_BOOKSHOP_PLAIN, FORM_PROVIDER_TABLE} from '../../util/consts/forms';
import {PROVIDER_PLAIN_PATH} from '../../util/routes';
import {performApiRequest, 
	ACTION_BOOKSHOP_GET_PROVIDER_TERMINAL_API_URL, ACTION_BOOKSHOP_GET_PROVIDER_MERCHANT_API_URL, 
	KATOTTG_GETPATH_API_URL
} from '../../util/restapi';
import {
	LOCALITY_TYPE_REGION, LOCALITY_TYPE_MEGA, LOCALITY_TYPE_DISTRICT, LOCALITY_TYPE_COMMUNITY,
	LOCALITY_TYPE_CITY, LOCALITY_TYPE_TOWN, LOCALITY_TYPE_VILLAGE, LOCALITY_TYPE_VILLAGE_SMALL, 
	LOCALITY_TYPE_DIVISION
} from '../../util/consts/common';


import iconAccept from '../../assets/icons/png24x24/Accept.png';
import iconInsert from '../../assets/icons/png24x24/insert.png';
import iconDelete from '../../assets/icons/png24x24/Delete.png';
import iconCheckMark from '../../assets/icons/png24x24/check_mark.png';

class BookShopPlainPage extends PlainPage {
	
	refProviderNodes = [
		{
			classId: CLASS_PROVIDER, plainFormPath: PROVIDER_PLAIN_PATH, 
			selectInstanceFormId: FORM_PROVIDER_TABLE,
			selectInstanceFormTitle: 'Постачальник'
		}
	];
	
	constructor(props) {
		super(props);
		this.refSelectTerminalsModal = React.createRef();
		this.refSelectMerchantsModal = React.createRef();
		this.formPath = FORM_BOOKSHOP_PLAIN;
		this.formTitle = 'Книгарня';
		this.userInfo = getUserInfo();
		this.buildInstanceCard = this.buildBookShopCard;
		this.state.isSelectMerchantsModalOpen=false;
		this.state.isSelectTerminalsModalOpen=false;
	}
	componentDidMount = async () => {
		this.init( CLASS_BOOKSHOP );
		document.title = 'BOM. ' + this.formTitle;
	}
	
	buildBookShopCard = (bookShopInstance) => {
		let card = '';
		if( bookShopInstance.rootField.value.localCode.value )
			card += '(' + bookShopInstance.rootField.value.localCode.value + ') ';
		if( bookShopInstance.rootField.value.name.value )
			card += bookShopInstance.rootField.value.name.value;
		return card;
	}
	
	createTab = (tabId) => {
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		if( tabId == 'communications' )
			return (
				<div style={{padding: '10px'}}>
					<FieldList_TableGroup instance={instance} path={'/communications'} plain={this} 
						plainDirtyCounter={this.state.plainDirtyCounter} ignoreTitle={true}
						readOnly={readOnly} 
						table={{
							columns: [
								{ columnId: 'type', styles: {tdHeader: {width: '20%'}} }, 
								{ columnId: 'value', styles: {tdHeader: {width: '40%'}} },
								{ columnId: 'notes', styles: {tdHeader: {width: '40%'}} },
							],
						}}
						styles={{
							table: {width: '100%'},
							trHeader: {height: '43px'}
						}}
					/>
				</div>
			);
		if( tabId == 'merchants' )
			return (
				<div style={{padding: '10px'}}>
					<MerchantList instance={instance} path={'/merchantList'} plain={this}
						plainDirtyCounter={this.state.plainDirtyCounter} ignoreTitle={true}
						readOnly={readOnly} disableMoveItems={true}
						createDataCellComponent={this.createMerchantDataCellComponent}
						createHeaderCellComponent={this.createMerchantHeaderCell}
						table={{
							columns: [
								{ columnId: 'mark', styles: {tdHeader: {width: '5%'}} },
								{ columnId: 'acquirerRef', styles: {tdHeader: {width: '35%'} } },
								{ columnId: 'mid', styles: {tdHeader: {width: '30%'} } },
								{ columnId: 'mcc', styles: {tdHeader: {width: '25%'} } },
								{ columnId: 'ebook', styles: {tdHeader: {width: '5%'}} },
							],
						}}
						styles={{
							table: {width: '100%'},
							trHeader: {height: '40px'}
						}}
					/>
				</div>
			);
		if( tabId == 'terminals' )
			return (
				<div style={{padding: '10px'}}>
					<TerminalList instance={instance} path={'/terminalList'} plain={this}
						plainDirtyCounter={this.state.plainDirtyCounter} ignoreTitle={true}
						readOnly={ readOnly } 
						createDataCellComponent={this.createTerminalCell} createHeaderCellComponent={this.createTerminalHeaderCell}
						table={{
							columns: [
								{ columnId: 'mark', styles: {tdHeader: {width: '5%'}} },
								{ columnId: 'acquirerRef', styles: {tdHeader: {width: '20%'}} },
								{ columnId: 'tid', styles: {tdHeader: {width: '20%'}} },
								/*{ columnId: 'ebook', styles: {tdHeader: {width: '5%'}} },*/
								{ columnId: 'comments', styles: {tdHeader: {width: '55%'}} },
							],
						}}
						styles={{
							table: {width: '100%'},
							trHeader: {height: '40px'}
						}}
					/>
				</div>
			);
		return <div>Unknown tabId: {tabId}</div>;
	}
	
	onKatottgSelected = async (code) => {
		let instance = this.state.instance;
		let fieldKatottg = instance.getField('/katottg');
		instance.setFieldValue(fieldKatottg, code);
		let request = {code: code}
		let response = await performApiRequest(KATOTTG_GETPATH_API_URL, request);
		if( ! response.success ) {
			this.props.app.showResponse( response, 'Katottg error' );
			return;
		}

		let fieldRegion = instance.getField('/region');
		let fieldDistrict = instance.getField('/district');
		let fieldCommunity = instance.getField('/community');
		let fieldCity = instance.getField('/city');
		
		for(let record of response.listKatottgRecord) {
			let category = record.categoryId;
			if( category == LOCALITY_TYPE_REGION || category == LOCALITY_TYPE_MEGA ) {
				let oldValue = fieldRegion.value;
				if( ! oldValue ) {
					let regionCode = record.code.substring(2,7);
					instance.setFieldValue(fieldRegion, regionCode);
				}
				if( category == LOCALITY_TYPE_MEGA ) {
					oldValue = fieldCity.value;
					if( ! oldValue ) {
						instance.setFieldValue(fieldCity, record.name);
					}
				}
			} else if ( category == LOCALITY_TYPE_DISTRICT || category == LOCALITY_TYPE_DIVISION ) {
				let oldValue = fieldDistrict.value;
				if( ! oldValue ) {
					instance.setFieldValue(fieldDistrict, record.name);
				}
			} else if ( category == LOCALITY_TYPE_COMMUNITY ) {
				let oldValue = fieldCommunity.value;
				if( ! oldValue ) {
					instance.setFieldValue(fieldCommunity, record.name);
				}
			} else if ( category == LOCALITY_TYPE_CITY || category == LOCALITY_TYPE_TOWN 
					|| category == LOCALITY_TYPE_VILLAGE || category == LOCALITY_TYPE_VILLAGE_SMALL ) 
			{
				let oldValue = fieldCity.value;
				if( ! oldValue ) {
					instance.setFieldValue(fieldCity, record.name);
				}
			}
		}
	}
	
	createMerchantHeaderCell = (columnId) => {
		if( columnId == 'mark' ) {
			return (<Label image={iconAccept} tooltip={'Позначка, чи є мерчант активним'} />);
		} else if( columnId == 'ebook' ) {
			let labelStyle = {color: 'black', fontWeight: 'bold', fontStyle: 'normal'}; 
			return (<Label title={'єКнига'} tooltip={'Позначка, чи приймає мерчант участь в програмі єКнига'} styles={{ divMain: labelStyle}} />);
		} else 
			return null;
	}
	createMerchantDataCellComponent = (columnId, rowIndex, instance, itemField, plain, plainDirtyCounter) => {
		let status = itemField.value.status.value;
		let idReadOnly = ( this.instanceReadOnly || itemField.ref.id ) ? true : false;		
		if( columnId == 'mark' ) {
			if( status == 'actual' ) {
				return <div style={{textAlign: 'center'}}><img src={iconCheckMark} /></div>
			} else {
				return <div></div>
			}
		} else if( columnId == 'acquirerRef' ) {
			return(
				<FieldRefList path={'acquirerRef'} instance={instance} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} classId={'EBookBank'} styles={{}}
					ignoreTitle={true} 
				/>
			)
		} else if( columnId == 'ebook' ) {
			let showMark = itemField.value.eBookParticipant.value == 1;
			if( showMark ) {
				return (<div style={{textAlign: 'center'}}><img src={iconCheckMark} /></div>);
			} else
				return (<div>&nbsp;</div>);
		} else if( columnId == 'mid' ) {
			return (
				<FieldString instance={instance} path={'mid'} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} ignoreTitle={true} styles={{ input: {width: 'calc(100% - 10px)'}}} 
				/>
			);
		}
		return null;
	}	
	
	createTerminalHeaderCell = (columnId) => {
		if( columnId == 'mark' ) {
			return (<Label image={iconAccept} tooltip={'Позначка, чи є термінал активним'} />);
		} else if( columnId == 'ebook' ) {
			let labelStyle = {color: 'black', fontWeight: 'bold', fontStyle: 'normal'}; 
			return (<Label title={'єКнига'} tooltip={'Позначка, чи приймає термінал участь в програмі єКнига'} styles={{ divMain: labelStyle}} />);
		} else 
			return null;


	}
	createTerminalCell = (columnId, rowIndex, instance, itemField, plain, plainDirtyCounter) => {
		let status = itemField.value.status.value;
		let userInfo = plain.userInfo;
		let idReadOnly = ( this.instanceReadOnly || itemField.ref.id ) ? true : false;		
		if( columnId == 'mark' ) {
			if( status == 'actual' ) {
				return <div style={{textAlign: 'center'}}><img src={iconCheckMark} /></div>
			} else {
				return <div></div>
			}
		} else if( status == 'devoid' && ! userInfo.permission.superuser ) {
			let value = '';
			if( columnId == 'tid' ) {
				value = itemField.value.tid.value;
			} else if(  columnId == 'bankCode' ) {
				value = itemField.value.bankCode.value;
			} else if(  columnId == 'comments' ) {
				value = itemField.value.comments.value;
			}
			return <div style={{color: 'gray'}}>{value}</div>
		} else if( columnId == 'acquirerRef' ) {
			return (
				<FieldRefList instance={instance} path={columnId} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} classId={'EBookBank'}
					ignoreTitle={true} styles={{}} 
				/>
			);
		} else if( columnId == 'ebook' ) {
			// let acquirerRef = itemField.value.acquirerRef.value;
			// let showMark = ! (acquirerRef == null || acquirerRef.id == null);
			let showMark = itemField.value.eBookParticipant.value == 1;
			if( showMark ) {
				return (<div style={{textAlign: 'center'}}><img src={iconCheckMark} /></div>);
			} else
				return (<div>&nbsp;</div>);
		} else if( columnId == 'tid' ) {
			return (
				<FieldString instance={instance} path={'tid'} plain={plain} readOnly={idReadOnly} 
					parentField={itemField} ignoreTitle={true} styles={{ input: {width: 'calc(100% - 10px)'}}} 
				/>
			);
		} else
			return null;

	}

	openSelectMerchantsModal = () => {
		this.setState({isSelectMerchantsModalOpen: true});
	}
	closeSelectMerchantsModal = () => {
		this.setState({isSelectMerchantsModalOpen: false});
	}
	selectMerchants = ( listMerchant ) => {
		let instance = this.state.instance;
		let fieldMerchants = instance.rootField.value.merchantList;
		let itemModel = fieldMerchants.model.item;
		for( let m of listMerchant ) {
			let item = instance.createObjectField( itemModel, m );
			instance.addListItem(fieldMerchants, item);
		}
	}

	openSelectTerminalsModal = () => {
		this.setState({isSelectTerminalsModalOpen: true});
	}
	closeSelectTerminalsModal = () => {
		this.setState({isSelectTerminalsModalOpen: false});
	}
	selectTerminals = ( listTerminal ) => {
		let instance = this.state.instance;
		let fieldRegion = instance.rootField.value.region;
		let fieldPlace = instance.rootField.value.place;
		let fieldTerminals = instance.rootField.value.terminalList;
		let itemModel = fieldTerminals.model.item;
		for( let t of listTerminal ) {
			let item = instance.createObjectField( itemModel, t );
			instance.addListItem(fieldTerminals, item);
			if( ! fieldRegion.value && t.area) {
				instance.setFieldValue(fieldRegion, t.area);
			}
			if( ! fieldPlace.value && t.address) {
				instance.setFieldValue(fieldPlace, t.address);
			}
		}
	}
	
	renderBody() {
		let instance = this.state.instance;
		let readOnly = this.instanceReadOnly;
		let tabs = [
			{
				rowId: 'first',
				tabs: [
					{ tabId: 'merchants', tabTitle: 'Мерчанти', }, 
					{ tabId: 'terminals', tabTitle: 'Термінали', },
					{ tabId: 'communications', tabTitle: 'Комунікації', }, 
				]
			},
		];
		let divPremisesAndAreaHtml = null;
		if( hasAccess(ACCESS_VIEW_BOOKSHOP_AREA, this.userInfo) ) {
			divPremisesAndAreaHtml = (
				<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
					<FieldEnum instance={instance} path={'/premises'} plain={this} 
						readOnly={readOnly}
						styles={{ select: {width: '200px', marginRight: '20px'}}} 
					/>
					<FieldDecimal instance={instance} path={'/totalArea'} plain={this}
						readOnly={this.readOnly}
						styleInput={{width: '60px', textAlign: 'right', marginRight: '20px'}} 
					/>
					<FieldDecimal instance={instance} path={'/shoppingArea'} plain={this}
						readOnly={this.readOnly}
						styleInput={{width: '60px', textAlign: 'right'}} 
					/>
				</div>
			)
		}
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FieldReference instance={instance} path={'/providerRef'} plain={this}
							refNodes={this.refProviderNodes}
							readOnly={this.readOnly}
							styles={{divMain: {flexGrow: '1'}}}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
						<FieldString instance={instance} path={'/name'} plain={this}
							styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldString instance={instance} path={'/localCode'} plain={this}
							styles={{ input: {width: '50px', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldEnum instance={instance} path={'/type'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0', marginRight: '20px'}}} 
						/>
						<FieldEnum instance={instance} path={'/status'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {flexGrow: '0'}}} 
						/>
					</div>			
					<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
						<FieldEnum instance={instance} path={'/country'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {width: '150px', marginRight: '20px'}}} 
						/>
						<FieldString instance={instance} path={'/index'} plain={this}
							styles={{ input: {width: '60px', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldString instance={instance} path={'/katottg'} plain={this}
							styles={{ input: {flexGrow: '1', width: '200px', marginRight: '5px'} }}
							readOnly={this.readOnly}
						 />
						<KatottgButton onKatottgSelected={this.onKatottgSelected} 
							styles={{button: {marginRight: '20px'}}}
						/>
						<FieldEnum instance={instance} path={'/region'} plain={this} 
							readOnly={readOnly}
							styles={{ select: {width: '200px', marginRight: '20px'}}} 
						/>
						<FieldString instance={instance} path={'/district'} plain={this}
							styles={{ input: {flexGrow: '1'} }}
							readOnly={this.readOnly}
						 />
					</div>			
					<div style={{display: 'flex', alignItems: 'center', marginTop: '20px' }}>
						<FieldString instance={instance} path={'/community'} plain={this}
							styles={{ input: {width: '280px', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldString instance={instance} path={'/city'} plain={this}
							styles={{ input: {width: '280px', marginRight: '20px'} }}
							readOnly={this.readOnly}
						 />
						<FieldString instance={instance} path={'/place'} plain={this}
							styles={{ input: {flexGrow: '1'} }}
							readOnly={this.readOnly}
						 />
					</div>
					{divPremisesAndAreaHtml}			
					<div style={{marginTop: '20px' }}>
						<FieldCheckBoxGroup instance={instance} path={'/accServiceSet'} plain={this}
							colCount={10} readOnly={this.readOnly}/>
					</div>			
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginTop: '15px'} }} 
					/>
					<div style={{marginTop: '20px', paddingRight: '9px'}}>
						<div>
							<LabelField instance={instance} path={'/comment'} />
						</div>
						<div>
							<FieldString instance={instance} path={'/comment'} plain={this}
								multiline={true} rows={4} cols={60} styles={{input: {width: '100%'}}}
								readOnly={this.readOnly}
							 />
						</div>
					</div>
				</div>
				<SelectMerchantsModal ref={this.refSelectMerchantsModal} plain={this} />
				<SelectTerminalsModal ref={this.refSelectTerminalsModal} plain={this} />
			</div>
		)
	}
}

class MerchantList extends FieldList_TableGroup {
	
	changeStatus = () => {
		let instance = this.props.instance;
		let index = this.state.selectedIndex;
		if( index < 0 || index >= this.field.value.length )
			return;
		let fieldStatus = this.field.value[index].value.status; 
		if( fieldStatus.value == 'devoid' )
			instance.setFieldValue(fieldStatus, 'actual');
		else
			instance.setFieldValue(fieldStatus, 'devoid');
		this.setState({ dirtyCounter: this.state.dirtyCounter+1});
	}
	createHeaderHtml() {
		
		let labelEmptyHtml = null;
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px', width: '100%'};
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonDeleteDisabled = readOnly; // || ! isUserSuperUser();
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{this.createButtonAddHtml()}
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.changeStatus} disabled={readOnly} title={'Змінити статус мерчантів'}
					>
						<img src={iconAccept} />
					</button>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.appendMerchants} disabled={readOnly} title={'Додати мерчантів з переліку вільних мерчантів'}
					>
						<img src={iconInsert} />
					</button>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.deleteItem} disabled={buttonDeleteDisabled} title={'Вилучити'}
					>
						<img src={iconDelete} />
					</button>
				</div>
			</div>
		);
		return headerHtml;
	}
	appendMerchants = async () => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let providerRef = instance.rootField.value.providerRef.value;
		if( ! providerRef || ! providerRef.id )
			return;
		let request = {providerId: providerRef.id}
		let response = await performApiRequest(ACTION_BOOKSHOP_GET_PROVIDER_MERCHANT_API_URL, request);
		if( ! response.success ) {
			plain.props.app.showResponse( response, 'Invalid provider' );
			return;
		}
		let listMerchant = response.listMerchant;
		for(let i=listMerchant.length-1; i >= 0;  i--) {
			let m = listMerchant[i];
			let ignore = false;
			if( m.bookShopId ) {
				ignore = true;
			}
			if( ignore ) {
				listMerchant.splice(i,1);
			}
		}
		if( listMerchant.length == 0 ) {
			let message = {
				title: 'Увага',
				mainMessage: 'У постачальника немає вільних мерчантів'
			};
			plain.props.app.showMessage( message );
			return;
		}
		
		plain.refSelectMerchantsModal.current.init(listMerchant);
		plain.openSelectMerchantsModal();
	}
	
}

class TerminalList extends FieldList_TableGroup {
	
	changeStatus = () => {
		let instance = this.props.instance;
		let index = this.state.selectedIndex;
		if( index < 0 || index >= this.field.value.length )
			return;
		let fieldStatus = this.field.value[index].value.status; 
		if( fieldStatus.value == 'devoid' )
			instance.setFieldValue(fieldStatus, 'actual');
		else
			instance.setFieldValue(fieldStatus, 'devoid');
		this.setState({ dirtyCounter: this.state.dirtyCounter+1});
	}
	appendTerminals = async () => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let providerRef = instance.rootField.value.providerRef.value;
		if( ! providerRef || ! providerRef.id )
			return;
		let request = {providerId: providerRef.id}
		let response = await performApiRequest(ACTION_BOOKSHOP_GET_PROVIDER_TERMINAL_API_URL, request);
		if( ! response.success ) {
			plain.props.app.showResponse( response, 'Invalid provider' );
			return;
		}
		let listTerminal = response.listTerminal;
		for(let i=listTerminal.length-1; i >= 0;  i--) {
			let t = listTerminal[i];
			let ignore = false;
			if( t.bookShopId ) {
				ignore = true;
			}
			/*
			for(let instanceTerminal of instance.rootField.value.terminals.value) {
				if( instanceTerminal.ref.id == t.id ) {
					ignore = true;
					break;
				}
			}
			*/
			if( ignore ) {
				listTerminal.splice(i,1);
			}
		}
		if( listTerminal.length == 0 ) {
			let message = {
				title: 'Увага',
				mainMessage: 'У постачальника немає вільних зареєстрованих терміналів'
			};
			plain.props.app.showMessage( message );
			return;
		}
		
		plain.refSelectTerminalsModal.current.init(listTerminal);
		plain.openSelectTerminalsModal();
	}
	
	createHeaderHtml() {
//		let plain = this.props.plain;
//		let userInfo = plain.userInfo;
//		let isSuperUser = userInfo.permission.superuser;
		let labelEmptyHtml = null;
		let divHeaderStyle = {display: 'flex', alignItems: 'center', marginBottom: '5px', width: '100%'};
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let buttonDeleteHtml = null;
//		if( isSuperUser ) {
			buttonDeleteHtml = 
				<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
					onClick={this.deleteItem} disabled={readOnly} title={'Прибрати зв\'язок з терміналом'}
				>
					<img src={iconDelete} />
				</button>
//		}
		let headerHtml = (
			<div style={divHeaderStyle}>
				{this.createTitleHtml()}
				{labelEmptyHtml}
				<div style={{display: 'flex'}}>
					{this.createButtonAddHtml()}
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.changeStatus} disabled={readOnly} title={'Змінити статус терміналів'}
					>
						<img src={iconAccept} />
					</button>
					<button type='button' className={stylesPlain.buttonIcon} style={{marginLeft: '15px'}}
						onClick={this.appendTerminals} disabled={readOnly} title={'Додати термінали з переліку вільних терміналів'}
					>
						<img src={iconInsert} />
					</button>
					{buttonDeleteHtml}
				</div>
			</div>
		);
		return headerHtml;
	}
}

export default BookShopPlainPage;
